import type { DefineComponent } from 'vue';

/**
 * Lives outside app.ts because Vite hoists an eager glob's imports above every
 * other import of the module that declares it, which would load all pages (and
 * their dependencies) before the polyfills that app.ts imports first.
 */
export const pages = import.meta.glob<{ default: DefineComponent }>('./Pages/**/*.vue', {
    eager: true,
});
